export interface DealDebtSchedule {
	guid: string;
	dealGuid: string;
	originalLoanAmount: number | null;
	presentBalance: number | null;
	interestRate: number | null;
	monthlyPayment: number | null;
	maturityDate: string | null;
	collateralSecurityType: CollateralSecurityTypes | null;
	dealFacilityId: number | null;
	isRefinance: boolean | null;
	amortization: number | null;
	facilityType: FacilityTypes | null;
	lenderType: LenderTypes | null;
	isTermLoan: boolean;
	isRevolver: boolean;
	notes: string | null;
}

export type FacilityTypes = keyof typeof FacilityTypeMap;

export const FacilityTypeMap = {
	Unknown: 'Unknown / TBD',
	Term_Loan: 'Term Loan',
	Revolver: 'Revolver',
	Letter_of_Credit: 'Letter of Credit',
	Line_of_Credit: 'Line of Credit',
	Bridge_Facility: 'Bridge Facility',
	Syndicated_Facility: 'Syndicated Facility',
	EquipmentLease: 'Equipment Lease',
	CapitalLease: 'Capital Lease',
	OperatingLease: 'Operating Lease',
	Bond: 'Bond',
	Warehouse: 'Warehouse',
	Factor: 'Factor',
	PurchaseOrderFinancing: 'Purchase Order Financing',
};

export type LenderTypes = keyof typeof LenderTypeMap;

export const LenderTypeMap = {
	Assessment: 'Asset-Based',
	Bank: 'Bank - Conventional',
	EquipmentBased: 'Equipment-Based',
	Factoring: 'Factoring',
	NonBank: 'Non-Bank / Direct Lender',
	Other: 'Individual / Other',
	Sba: 'SBA',
	SellerFinancing: 'Seller Financing',
	Usda: 'USDA',
	Unknown: 'Unknown',
};

export type CollateralSecurityTypes = keyof typeof CollateralSecurityTypeMap;

export const CollateralSecurityTypeMap = {
	SecuredAr: 'Secured - A/R',
	SecuredInventory: 'Secured - Inventory',
	SecuredRealEstate: 'Secured - Owner Occupied Real Estate',
	SecuredGeneral: 'Secured - General / 1st Lien',
	SecuredCash: 'Secured - Cash',
	SecuredSecurities: 'Secured - Marketable Securities',
	SecuredEquipment: 'Secured - Machinery & Equipment',
	SecuredOther: 'Secured - Other',
	Unsecured: 'Unsecured',
	SecuredArPlusInventory: 'Secured - A/R + Inventory',
	SecuredVehicles: 'Secured - Vehicles',
	SecuredMarine: 'Secured - Marine Vessels',
	SecuredHelicopters: 'Secured - Helicopters',
	SecuredFixedWingAircraft: 'Secured - Fixed Wing Aircraft',
	SecondLienRealEstate: 'Second Lien - Owner Occupied Real Estate',
	SecuredIp: 'Secured - Intellectual Property',
	SecuredRoyalty: 'Secured - Royalty/Licensing',
	SecuredFirstLien: 'Secured - First Lien All Business Assets',
	SecondLien: 'Second Lien',
	Mezzanine: 'Mezzanine',
	SecuredSecondLien: 'Secured - Second Lien All Business Assets',
};
